const Config = {
    BACKEND_ADDR: `${window.location.origin}/api`,
    CLOUD_ADDR: `${window.location.origin}/cloud`,
    SENTRY_DSN: "https://13c35fd0222ab9cd307555577872909d@o4508977065885696.ingest.de.sentry.io/4508977095508048",
    PUBLIC_URL: ""
}; 

export default Config